import {getIssuerByCardNumber} from './utils'

const validateRequired = function (value) {
  return !!value.length;
}

const validateCardNumberLength = function (value, [regex, length]) {
  return value.split(' ').join('').length === parseInt(length, 10)
}

const validateCvvLength = function (value, [regex, length]) {
  return value.length === parseInt(length, 10)
}

const validateCardOwnerName = function (value) {
  const pattern = /^[a-zA-Z.~'` \-ÁáÀàÂâÄäÃãÇçÉéÈèÊêËëÍíÎîÏïÑñÓóÔôÕõOEoeÚúÙùÛûÜüŸÿÆæĄąĆćĘęŁłŃńŚśŹźŻż]{1,24}$/;

  return pattern.test(value);
}

const validateCardType = function (value, [regex, issuer]) {
  const valueCards = getIssuerByCardNumber(value)
  if (!issuer) {
    return true
  }
  return Array.isArray(valueCards) ? valueCards.includes(issuer) : valueCards === issuer
}

const rulesMap = {
  'required': validateRequired,
  'cardNumber([1-90]+)': validateCardNumberLength,
  'cvv([1-90]+)': validateCvvLength,
  'cardOwnerName': validateCardOwnerName,
  'cardType-([A-Z]+)': validateCardType,
}

const validate = function (rules, value) {
  const validation = rules.map(function (rule) {
    const handler = Object.keys(rulesMap).map(keyMask => {
      const ruleMatch = rule.match(keyMask)
      if (ruleMatch) {
        return rulesMap[keyMask](value, ruleMatch)
      }
      return true
    })
    return handler.every(el => !!el)
  })
  return validation.every(el => !!el)
}

export default validate;
